import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Register service worker for production (PWA: installability, update notification)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  const ONE_HOUR_MS = 60 * 60 * 1000;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registered successfully:', registration);

        const dispatchUpdate = () => {
          window.dispatchEvent(new CustomEvent('swUpdate', { detail: registration }));
        };

        if (registration.waiting) dispatchUpdate();

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (registration.waiting) dispatchUpdate();
          });
        });

        setInterval(() => registration.update(), ONE_HOUR_MS);
      })
      .catch((error) => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
